import React from 'react';
import { Box, Typography, IconButton, Icon, Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { palette, spaces } from '../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../utils/getMuiIcon';

interface Props {
  isEditMode: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onSave: () => void;
}

const ProfileHeader: React.FC<Props> = ({ isEditMode, onEdit, onCancel, onSave }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography
        variant='h6'
        color={palette.text.primary}
        sx={{ py: spaces.md }}
      >
        {t('My Profile')}
      </Typography>

      {!isEditMode ? (
        <IconButton
          data-testid='edit-profile-button' 
          onClick={onEdit} 
          size='small' 
          color='secondary'
          aria-label={t('Edit profile')}
        >
          <Icon
            component={getMuiIcon('editPen')}
            sx={{ width: 32, height: 32 }}
          />
        </IconButton>
      ) : (
        <Stack direction='row' spacing={spaces.xs}>
          <Button 
            variant='outlined' 
            color='primary'
            size='medium'  
            onClick={onCancel}
          >
            {t('Cancel')}
          </Button>
          <Button 
            variant='contained' 
            color='primary' 
            size='medium' 
            onClick={onSave}
          >
            {t('Save')}
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default React.memo(ProfileHeader);
